import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/faqs';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-101" data-mp="1gk59wx5ypkok">
      <div className="mx-auto max-w-3xl" data-id="element-102" data-mp="248o9moay4p51">
        <SectionHeading title="Frequently asked questions" data-id="element-103" data-mp="249zmddmdd78a" />
        <ul className="mt-10 space-y-3" data-id="element-104" data-mp="28b1bh1mko2wj">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-canvas" data-id="element-105" data-mp="1uj4mv7k44b4w" data-mpi={i}>
                <h3 data-id="element-106" data-mp="1zh6h8omznwvo">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-electric-500" data-id="element-107" data-mp="1zgn0vcczlgjr">
                    <span data-id="element-108" data-mp="1eldaadijb383">{f.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-electric-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-109" data-mp="1emeouryre7uk" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-110" data-mp="1xjzbdse1wuc0">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-111" data-mp="1xhllrz254abu">
                      <div className="space-y-2 px-5 pb-5 text-[15px] leading-relaxed text-muted" data-id="element-112" data-mp="1ya4vsu1uy0wa">
                        {f.a.map(p => <p key={p} data-id="element-113" data-mp="23aagtrdmgp5e">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <CtaButton label="Yes, I'm ready to start" className="mt-12" data-id="element-114" data-mp="2h8h4yfsrrarv" />
      </div>
    </section>;
}